import script from "./MmMaterialsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MmMaterialsDetail.vue?vue&type=script&setup=true&lang=js"

import "./MmMaterialsDetail.vue?vue&type=style&index=0&id=232aa11e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-232aa11e"]])

export default __exports__